import Modal from "react-modal";
import { useState } from "react";
import stylesModule from "../../css/privateKey.module.css";
import styles from "./BackUpModal.module.css";
import Button from "../shared/Button";
import { useEffect } from "react";
import useTheme from "../../config/useTheme";
import useCustomStyles from "../../config/useCustomStyles";
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';
import { useBackupDatabase } from "../../api/database/useDatabase";
import Loader from "../shared/loader/Loader";

export default function BackUpModal({ openModal, setOpenModal }) {
  const { fullBackup, partialBackUp } = openModal;
  const { dark } = useTheme();
  const [step, setStep] = useState(1);
  const { compositionNames } = useCompositionsContext();
  const [compositionsForBackUp, setCompositionsForBackUp] = useState([]);
  
  const { response, loading, error, createBackup, resetServerStatus } = useBackupDatabase();
  const initialRemoteReqData = {
    host: "",
    user: "",
    password: "",
    method: "",
    path: "",
  };
  const [remoteReqData, setRemoteReqData] = useState(initialRemoteReqData);
  const customStyles = useCustomStyles();

  const downloadBackUp = () => {
    const options = {
      full_backup: fullBackup,
      compositions: compositionsForBackUp,
      remote: step === 4,
      method: remoteReqData.method,
      host: remoteReqData.host,
      user: remoteReqData.user,
      password: remoteReqData.password,
      path: remoteReqData.path
    };
    console.log(`Options: ${JSON.stringify(options)}`);
    createBackup(options);
    setStep(2);
  };
  const handleSelectComposition = (e) => {
    if (e.target.checked) {
      setCompositionsForBackUp((prev) => [...prev, e.target.id]);
    } else {
      setCompositionsForBackUp((prev) =>
        prev.filter((comp) => comp !== e.target.id),
      );
    }
  };

  const handleModal = (e) => {
    const { id } = e.target;
    switch (id) {
      case "Local":
        downloadBackUp();
        break;
      case "Send Remote":
        setStep(4);
        break;
      case "Cancel":
        setStep(1);
        setOpenModal((prev) => ({
          ...prev,
          [fullBackup ? "fullBackup" : "partialBackUp"]: false,
        }));
        setCompositionsForBackUp([]);
        setRemoteReqData(initialRemoteReqData);
        resetServerStatus();
        break;
      case "Finished":
        setStep(1);
        setOpenModal((prev) => ({
          ...prev,
          [fullBackup ? "fullBackup" : "partialBackUp"]: false,
        }));
        setCompositionsForBackUp([]);
        setRemoteReqData(initialRemoteReqData);
        resetServerStatus();
        break;
      case "Confirm":
        setStep(1);
        break;
      default:
        return;
    }
  };

  const handleInput = (e) => {
    const { id } = e.target;
    switch (id) {
      case "Host":
        setRemoteReqData((prev) => ({ ...prev, host: e.target.value }));
        break;
      case "Username":
        setRemoteReqData((prev) => ({ ...prev, user: e.target.value }));
        break;
      case "Password":
        setRemoteReqData((prev) => ({ ...prev, password: e.target.value }));
        break;
      case "FTP":
        setRemoteReqData((prev) => ({ ...prev, method: e.target.value }));
        break;
      case "SFTP":
        setRemoteReqData((prev) => ({ ...prev, method: e.target.value }));
        break;
      case "Path":
        setRemoteReqData((prev) => ({ ...prev, path: e.target.value }));
        break;
      default:
        return;
    }
  };

  useEffect(() => {
    if (partialBackUp) {
      setStep(3);
    }
  }, [partialBackUp]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div
            className={`${stylesModule.privateKey} ${
              dark ? stylesModule.dark : ""
            }`}
          >
            <div className={stylesModule.text}>
              <h2>{fullBackup ? "Full BackUp" : "Partial BackUp"} </h2>
            </div>
            <div className={stylesModule.btnGroup}>
              <Button id="Local" onClick={handleModal} text="Local" />
              <Button
                id="Send Remote"
                onClick={handleModal}
                text="Send Remote"
              />
            </div>
            <div className={stylesModule.btnGroup}>
              <Button id="Cancel" onClick={handleModal} text="Cancel" />
            </div>
          </div>
        );
      case 2:
        return (
          <div
            className={`${stylesModule.privateKey} ${
              dark ? stylesModule.dark : ""
            }`}
          >
            <div className={stylesModule.text}>
              <h2>{loading ? "Creating Backup..." : response?.status ? "Backup Created" : "Backup Failed"}</h2>
            </div>

            {loading ? (
              <>
                <p>Please wait while the backup is being created...</p>
                <p>This may take a while depending on the size of the database and the number of compositions.</p>
                <Loader />
                <div className={stylesModule.btnGroup}>
                  <Button id="Cancel" onClick={handleModal} text="Cancel" />
                </div>
              </>
            ) : response?.status ? (
              <>
                <p>{response?.message || "Backup created successfully"}</p>
                <div className={stylesModule.btnGroup}>
                  <Button id="Finished" onClick={handleModal} text="OK" />
                </div>
              </>
            ) : (
              <>
                <p>{error || response?.message || response?.error || "Unable to create backup"}</p>
                <p>Details: {response?.error || "Unknown error"}</p>
                <div className={stylesModule.btnGroup}>
                  <Button id="Cancel" onClick={handleModal} text="OK" />
                </div>
              </>
            )}
          </div>
        );
      case 3:
        return (
          <div
            className={`${stylesModule.privateKey} ${
              dark ? stylesModule.dark : ""
            }`}
          >
            <div className={stylesModule.text}>
              <h2>Collection</h2>
            </div>
            {compositionNames.map((composition) => (
              <div className={styles.selectComposition} key={composition}>
                <input
                  className={styles.selectCompositionInput}
                  onChange={handleSelectComposition}
                  type="checkbox"
                  id={composition}
                  name={composition}
                />
                <label className={styles.selectCompositionLabel} htmlFor={composition}>{composition}</label>
              </div>
            ))}
            <div className={stylesModule.btnGroup}>
              <Button
                disabled={compositionsForBackUp.length === 0}
                id="Confirm"
                onClick={handleModal}
                text="Confirm"
              />
              <Button id="Cancel" onClick={handleModal} text="Cancel" />
            </div>
          </div>
        );
      case 4:
        return (
          <div
            className={`${stylesModule.privateKey} ${
              dark ? stylesModule.dark : ""
            }`}
          >
            <div className={stylesModule.text}>
              <h2>Send Remote</h2>
            </div>
            <div className={stylesModule.radioButtons}>
              <input
                className={styles.selectCompositionInput}
                onChange={handleInput}
                type="radio"
                id="FTP"
                name="FTP/SFTP"
                value="ftp"
              />
              <label className={styles.selectCompositionLabel} htmlFor="FTP">FTP</label>
              <input
                className={styles.selectCompositionInput}
                onChange={handleInput}
                type="radio"
                id="SFTP"
                name="FTP/SFTP"
                value="sftp"
              />
              <label className={styles.selectCompositionLabel} htmlFor="SFTP">SFTP</label>
            </div>
            <input
              id="Host"
              onChange={handleInput}
              value={remoteReqData.host ? remoteReqData.host : ""}
              type="text"
              placeholder="Host"
            />
            <input
              id="Username"
              onChange={handleInput}
              value={remoteReqData.user ? remoteReqData.user : ""}
              type="text"
              placeholder="Username"
            />
            <input
              id="Password"
              onChange={handleInput}
              value={remoteReqData.password ? remoteReqData.password : ""}
              type="password"
              placeholder="Password"
            />
            <input
              id="Path"
              onChange={handleInput}
              value={remoteReqData.path ? remoteReqData.path : ""}
              type="text"
              placeholder="Remote Path (optional)"
            />
            <div className={stylesModule.btnGroup}>
              <Button
                disabled={remoteReqData.method === "" || !remoteReqData.host || !remoteReqData.user || !remoteReqData.password}
                onClick={downloadBackUp}
                text="OK"
              />
              <Button id="Cancel" onClick={handleModal} text="Cancel" />
            </div>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <Modal
      isOpen={fullBackup || partialBackUp}
      ariaHideApp={false}
      style={customStyles}
      contentLabel="Modal"
    >
      {renderStep()}
    </Modal>
  );
}
